import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[boiClickOutside]'
})
export class ClickOutsideDirective {
  @Output()
  public readonly boiClickOutside = new EventEmitter<MouseEvent>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);

    if (targetElement && !clickedInside) {
      this.boiClickOutside.emit(event);
    }
  }
}
